module.exports = __webpack_public_path__ + "static/media/logo.e4a5bc8d.png";